import { library, dom } from '@fortawesome/fontawesome-svg-core';

// only import the icons that we need (will create a significantly smaller font download)
import {
  faArrowLeft,
  faArrowRight,
  faBan,
  faBullseye,
  faCheck,
  faCheckSquare,
  faCircleNotch,
  faEllipsisH,
  faEnvelopeOpen,
  faExclamationCircle,
  faEye,
  faEyeSlash,
  faFileAlt,
  faLock,
  faMoon,
  faNotesMedical,
  faPencilAlt,
  faPlus,
  faPrint,
  faSignInAlt,
  faSignOutAlt,
  faSync,
  faTimes,
  faUndo,
  faUserCircle,
  faUserShield,
  faUsers,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';

import {
  faCheckSquare as farCheckSquare,
  faSquare as farSquare,
} from '@fortawesome/free-regular-svg-icons';

dom.watch();
// This will kick of the initial replacement of i to svg tags and configure a MutationObserver

// add imported icons to the icon library
library.add(
  faArrowLeft,
  faArrowRight,
  faBan,
  faBullseye,
  faCheck,
  faCheckSquare,
  faCircleNotch,
  faEllipsisH,
  faEnvelopeOpen,
  faExclamationCircle,
  faEye,
  faEyeSlash,
  faFileAlt,
  faLock,
  faMoon,
  faNotesMedical,
  faPencilAlt,
  faPlus,
  faPrint,
  farCheckSquare,
  farSquare,
  faSignInAlt,
  faSignOutAlt,
  faSync,
  faTimes,
  faUndo,
  faUserCircle,
  faUserShield,
  faUsers,
  faTrashAlt,
);
